import {WysiwygType} from '../../types'
import {Memoize} from '../../util/memoize'
import {CookieCategoryModel} from './CookieCategoryModel'
import {CookieSettingsModel} from './CookieSettingsModel'

export type CookieServiceKey = string

export type CookiesServiceConfig = {
	id: number
	key: string
	title: string
	text: WysiwygType
	missing_consent: WysiwygType
	cookie: {
		catgory: string
		service: string
	}
	cookies: Array<{
		name: string
		description: string
		retention: string
		custom: {
			amount: string
			unit: 'days' | 'months' | 'years'
		}
	}>
}

export class CookieServiceModel {
	constructor(
		readonly category: CookieCategoryModel,
		readonly config: CookiesServiceConfig
	) {}

	@Memoize()
	get enabled(): boolean {
		if (this.category.state === true) return true
		return new Set(this.category.state).has(this.key)
	}

	@Memoize()
	get key(): CookieServiceKey {
		return `${this.category.key}_${this.config.key || this.config.id}`
	}

	// ----- State changes ----- //
	toggle(): CookieSettingsModel {
		return this.category.toggleService(this)
	}
}
